import Api from '../../../helpers/Api';

export const SET_MUSIC_DATA = 'SET_MUSIC_DATA';
export const setMusicData = (musicData) => ({
    type: SET_MUSIC_DATA,
    data: musicData,
});

export const RESET_SINGLE_MUSIC = 'RESET_SINGLE_MUSIC';
export const resetSingleMusicData = () => ({
    type: RESET_SINGLE_MUSIC,
});

export const SET_PENDING_SLUG = 'SET_PENDING_SLUG';
const setPendingSlug = (pendingSlug) => ({
    type: SET_PENDING_SLUG,
    pendingSlug,
});

export const SET_IS_LOADING = 'SET_IS_LOADING';
export const setIsLoading = (isLoading) => ({
    type: SET_IS_LOADING,
    isLoading,
});

export const SET_SINGLE_MUSIC = 'SET_SINGLE_MUSIC';
const _setSingleMusic = (data) => ({
    type: SET_SINGLE_MUSIC,
    data,
});

export const SET_NOT_FOUND = 'SET_NOT_FOUND';
export const setNotFound = (notFound) => ({
    type: SET_NOT_FOUND,
    notFound,
});

export const SET_NEWS_SINGLE_MUSIC = 'SET_NEWS_SINGLE_MUSIC';
const setNews = (news) => ({
    type: SET_NEWS_SINGLE_MUSIC,
    news,
});

export const SET_IS_RELATED_NEWS = 'SET_IS_RELATED_NEWS';
const setIsRelatedNews = (isRelatedNews) => ({
    type: SET_IS_RELATED_NEWS,
    isRelatedNews,
});

export const fetchLatestNews = (limitNews = 6) => (dispatch) => Api.progressGet(dispatch, `/api/v1/news/getNews/0/${limitNews}/false/false`).then((json) => {
    if (json.status === 'success') {
        const myPromise = [
            dispatch(setIsRelatedNews(false)),
            dispatch(setNews(json.data)),
        ];

        return Promise.all(myPromise);
    }

    throw `error from server: ${json.message}`;
}).catch((error) => {
    // eslint-disable-next-line no-console
    console.log('fetchLatestNews got error: ', error);
}).finally(() => {
    dispatch(setIsLoading(false));
});


export const fetchRelatedNews = (limitNews = 6, tags) => (dispatch) => Api.progressGet(dispatch, `/api/v1/news/getRelatedNews/${limitNews}/${tags}`).then((json) => {
    if (json.status === 'success') {
        // if don't got at least 6  related news,  get of latest news
        if (json.data.length >= 6) {
            const myPromise = [
                dispatch(setNews(json.data)),
                dispatch(setIsRelatedNews(true)),
            ];

            return Promise.all(myPromise);
        }

        return dispatch(fetchLatestNews(limitNews));
    }

    // if have problem with related news or return 0 news, get latestnews
    return dispatch(fetchLatestNews(limitNews));
}).catch((error) => {
    // eslint-disable-next-line no-console
    console.log('fetchRelatedNews got error: ', error);
}).finally(() => {
    dispatch(setIsLoading(false));
});

export const getSingleMusicDataIfNeeded = (artistSlug, musicSlug) => (dispatch, getState) => {
    const musicSingleState = getState().musics.musicSingle;
    const singleMusicData = musicSingleState.singleMusicData;

    if (singleMusicData && artistSlug === singleMusicData.artistSlug && musicSlug === singleMusicData.musicSlug) {
        return Promise.resolve(1);
    }

    // Guard against redundant re-dispatches for the same artist/track while a fetch is
    // already in flight (tracked in state, same convention as e.g. artists' currentSlug or
    // top10's lastIdCategory - not a module-level variable, which would leak across
    // concurrent SSR requests sharing this module). `singleMusicData` stays empty until the
    // fetch resolves, so a component update firing again in the meantime (e.g.
    // componentDidUpdate re-checking the URL slug against the still-empty data) would
    // otherwise re-trigger this whole reset+fetch cycle on every render until the promise
    // settles - each dispatch below is synchronous and can itself cause another render
    // before this function returns, which can cascade into a call-stack overflow.
    const requestedKey = `${artistSlug}/${musicSlug}`;

    if (musicSingleState.pendingSlug === requestedKey) {
        return Promise.resolve(1);
    }

    dispatch(setPendingSlug(requestedKey));

    dispatch(resetSingleMusicData());

    dispatch(setNews([]));

    dispatch(setIsLoading(true));

    const query = `api/v1/getSingleMusicData/${artistSlug}/${musicSlug}`;

    return Api.progressGet(dispatch, query)
        .then((json) => {
            if (json.status === 'success') {
                const creatingTags = [];

                creatingTags.push(json.data.artistName);

                creatingTags.push(json.data.artistName.replace(/\s/g, '').toLowerCase());

                const artistTags = encodeURIComponent(creatingTags.join('_'));
                const myPromise = [
                    dispatch(_setSingleMusic(json.data)),
                    dispatch(fetchRelatedNews(10, artistTags)),
                ];

                return Promise.all(myPromise);
            }

            if (json.status === 404) {
                return dispatch(setNotFound(true));
            }

            throw `error from server: ${json.message}`;
        })
        // eslint-disable-next-line no-console
        .catch((err) => console.log('getSingleMusicDataIfNeeded got error:', err))
        .finally(() => {
            if (getState().musics.musicSingle.pendingSlug === requestedKey) {
                dispatch(setPendingSlug(null));
            }

            dispatch(setIsLoading(false));
        });
};
